<img obgImageContent="general.casino-not-available" />
<div>
	<h2 [innerHtml]="'general.ios-native-block.text.header' | translate"></h2>
	<p [innerHtml]="'general.ios-native-block.text' | translate"></p>
	<a *ngIf="openSiteInBrowserDeeplink" (click)="openSiteInBrowser($event)">
		{{ "general.ios-native-block.visitwebsite" | translate }}
	</a>
</div>
